















































import { Vue, Component, Prop, Model } from "vue-property-decorator";

@Component
export default class StateButtonWithSelectionListComponent<T> extends Vue {
  @Prop()
  tooltip!: string;

  @Prop({ default: null })
  iconResource!: string | null;

  @Prop()
  selectedValueDescription!: string;

  @Prop({ default: [] })
  selectionOptions!: Array<T>;

  @Prop()
  getOptionName!: (value: T) => string;

  @Prop()
  getOptionKeyCallback?: (value: T) => string;

  @Prop({ default: null })
  fontSize!: string | null;

  getOptionKey(value: T) {
    if (this.getOptionKeyCallback) {
      return this.getOptionKeyCallback(value);
    } else {
      value;
    }
  }

  get textStyle() {
    if (!this.fontSize) {
      return null
    }

    return {
      "font-size": this.fontSize,
    };
  }

  @Model("valueChanged")
  selectedValue!: T;

  get selectedValues() {
    const keySelected = this.getKey(this.selectedValue);
    return [keySelected];
  }

  selectOption(value: T) {
    this.$emit("valueChanged", value);
  }

  getKey(value: T) {
    return this.getOptionKeyCallback ? this.getOptionKeyCallback(value) : value;
  }
}
